import React from 'react';
import { Layers, Zap } from 'lucide-react';
import './BlurBgControls.css';

const BlurBgControls = ({ settings, onChange }) => {
    // Default blur strength is 15 (Subtle Portrait) if not set
    const blurStrength = settings.blurStrength || 15;

    const handleChange = (e) => {
        onChange({ ...settings, blurStrength: parseInt(e.target.value, 10) });
    };

    return (
        <div className="blur-bg-controls fade-in">
            
            {/* Control Header */}
            <div className="control-header">
                <label className="section-label">Blur Intensity</label>
                <span className="value-badge">{blurStrength}%</span>
            </div>

            {/* Slider Component */}
            <div className="slider-group">
                <div className="slider-track-bg">
                    <div 
                        className="slider-track-fill" 
                        style={{ width: `${(blurStrength / 50) * 100}%` }}
                    />
                </div>
                <input 
                    type="range" 
                    min="0" 
                    max="50" 
                    step="1"
                    value={blurStrength}
                    onChange={handleChange}
                    className="custom-range-slider"
                />
            </div>

            {/* Visual Hints */}
            <div className="slider-labels">
                <span>Sharp</span>
                <span>Creamy Bokeh</span>
            </div>

            {/* Quick Presets */}
            <div className="preset-chips">
                <button 
                    className={`chip ${blurStrength === 5 ? 'active' : ''}`} 
                    onClick={() => onChange({ ...settings, blurStrength: 5 })}
                >
                    Subtle
                </button>
                <button 
                    className={`chip ${blurStrength === 15 ? 'active' : ''}`} 
                    onClick={() => onChange({ ...settings, blurStrength: 15 })}
                >
                    Portrait
                </button>
                <button 
                    className={`chip ${blurStrength === 40 ? 'active' : ''}`} 
                    onClick={() => onChange({ ...settings, blurStrength: 40 })}
                >
                    Macro
                </button>
            </div>

            {/* Info Box */}
            <div className="info-box-tool">
                <Zap size={14} className="icon-accent" />
                <p>Adjusting the slider generates a new depth map instantly.</p>
            </div>

        </div>
    );
};

export default BlurBgControls;